import { render } from "preact";
import type { InlineConfig } from "../shared/types.js";
import { isDesktop } from "../shared/detect.js";
import { trackImpression } from "../shared/tracking.js";
import { InlineWidget } from "./inline-widget.js";
import { MobileLink } from "../shared/mobile-link.js";
import css from "../styles/tailwind.css?inline";

export function renderInline(hostEl: HTMLElement, config: InlineConfig): void {
  if (config.width === "full") {
    hostEl.style.display = "block";
    hostEl.style.width = "100%";
  }

  let shadow = hostEl.shadowRoot;
  if (shadow) {
    shadow.innerHTML = "";
  } else {
    shadow = hostEl.attachShadow({ mode: "open" });
  }

  const style = document.createElement("style");
  style.textContent = css;
  shadow.appendChild(style);

  const root = document.createElement("div");
  root.style.fontFamily = "system-ui, -apple-system, sans-serif";
  shadow.appendChild(root);

  const component = isDesktop()
    ? <InlineWidget config={config} />
    : <MobileLink config={config} newTab={config.mobileNewTab ?? true} />;

  render(component, root);
  (hostEl as any).__fvUnmount = () => render(null, root);
  if (!config.preview) {
    trackImpression(config.embedApiUrl, config.formId, config.embed, config.attribution, hostEl);
  }
}
